import script from "./AuthLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthLayout.vue?vue&type=script&setup=true&lang=ts"

import "./AuthLayout.vue?vue&type=style&index=0&id=33c37ad8&scoped=true&lang=less"

import exportComponent from "/Users/jeff/projects/js/pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33c37ad8"]])

export default __exports__